var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatutGrisLieCdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,12c0-2,1.6-3.6,3.6-3.6h4.6V6.3H6.3c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8h4.6v-2.2H6.3C4.3,15.6,2.7,14,2.7,12 C2.7,12,2.7,12,2.7,12 M7.4,13.1h9.2v-2.3H7.4V13.1 M17.8,6.2h-4.6v2.2h4.6c2,0.1,3.5,1.8,3.4,3.8c-0.1,1.8-1.6,3.3-3.4,3.4h-4.6 v2.2h4.6c3.2,0,5.8-2.6,5.8-5.8S20.9,6.3,17.8,6.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutGrisLieCdf);
export default __webpack_public_path__ + "static/media/statut_gris_lie-cdf.2ac92e27.svg";
export { ForwardRef as ReactComponent };